import React from 'react';
import { LabeledValueWrapper, LValue, LLabel } from './styled/SLabeledValue';

interface LabeledValueProps {
    label: string;
    value: string;
    id?: string;
}

function LabeledValue(props: LabeledValueProps) {
    return <LabeledValueWrapper id={props.id}>
        <LLabel className={'label'}>{props.label}</LLabel>
        <LValue className={'value'}>{props.value}</LValue>
    </LabeledValueWrapper>;
}

export default LabeledValue;
